export const NEWLY_LISTED_FILTER_SHORT_NAME = "newlyListed"
export const newlyListedDefault = false

const sN = NEWLY_LISTED_FILTER_SHORT_NAME
const dV = newlyListedDefault

export const NEWLY_LISTED_FILTER_CONFIG = {
  short_name: sN,
  default_values: dV,
  is_default: value => testNewlyListedDefault(value), //right before clean up
  format_to_api: value => formatNewlyListedForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatNewlyListedFromURL(value) //
}

export const formatNewlyListedFromURL = value => {
  if (typeof value === 'boolean') {
    return value
  }

  return value === 'true' ? true : false
}

export const testNewlyListedDefault = value => {
  if (value !== newlyListedDefault) {
    return false
  }
  return true
}

//api
export const formatNewlyListedForAPI = value => {
  if (value) {
    return {
      newly_listed: value
    }
  } else {
    return {}
  }
}